import * as React from 'react';
import SbEditable from 'storyblok-react';

import { renderStoryblokRichText } from '../../../utils/renderStoryblokRichText';

type Props = {
  blok: Credits;
};

const Credits: React.FC<Props> = ({ blok }) => {
  return (
    <div className="grid-section md:pb-2">
      <div className="col-span-3 hidden md:block" />
      {/* @ts-expect-error require storyblok-react upgrade */}
      <SbEditable key={blok._uid} content={blok}>
        <div className="textArea col-span-12 text-neutral-4 md:col-span-6">
          {blok.text && renderStoryblokRichText(blok.text)}
        </div>
      </SbEditable>
      <div className="col-span-3 hidden md:block" />
    </div>
  );
};

export default Credits;
